module.exports = __webpack_public_path__ + "img/m-banner-ugevkzdv-vi-VN.f0a08ea2.jpg";